let submit_symposium = (function( $ ) {

	let $form;

	let $move_to_submitted_button;

	let $overview;

	let $declined;

	let _init = function() {
		$form = $( '#self_organised_symposium_form' );

		if ( $form.length > 0 ) {
			let checkboxes = $form.find( 'input.i-am-presenter' );
			checkboxes.on( 'change', _i_am_presenter_change );

			checkboxes.each( function() {
				if ( $( this ).is( ':checked' ) ) {
					let presenter_no = $( this ).attr( 'name' ).slice(-1);

					$form.find( '#self_organised_symposium_form-sos_presenter_' + presenter_no + '_email' ).prop( 'disabled', true );
					$form.find( '#self_organised_symposium_form-sos_presenter_' + presenter_no + '_first_name' ).prop( 'disabled', true );
					$form.find( '#self_organised_symposium_form-sos_presenter_' + presenter_no + '_last_name' ).prop( 'disabled', true );
				}
			} );

			$declined = $form.find( '.presenter-declined' );

			if ( $declined.length > 0 ) {
				$declined.closest( '.row' ).prev( '.row' ).hide();

				$declined.find( 'a.collapse-wrap' ).on( 'click', function(e) {
					e.preventDefault();
					$( this ).closest( '.row' ).prev( '.row' ).slideDown();
					$( this ).closest( '.presenter-declined' ).slideUp();
				} );
			}
		}

		$move_to_submitted_button = $( 'a.symposium-to-submitted' );

		if ( $move_to_submitted_button.length > 0 ) {
			$move_to_submitted_button.on( 'click', _move_to_submitted );
		}

		$overview = $( '#self_organised_symposium_form-sos_overview' );

		if ( $overview.length > 0 ) {
			_update_word_count();

			$overview.on( 'keydown', _update_word_count );
			$overview.on( 'keyup', _update_word_count );
			$overview.on( 'change', _update_word_count );
		}
	};

	let _i_am_presenter_change = function( e ) {
		let presenter_no = $( this ).attr( 'name' ).slice(-1);

		if ( $( this ).is( ':checked' ) ) {
			$form.find( 'input.i-am-presenter' ).not( this ).prop( 'disabled', true );
			$form.find( '#self_organised_symposium_form-sos_presenter_' + presenter_no + '_email' ).prop( 'disabled', true );
			$form.find( '#self_organised_symposium_form-sos_presenter_' + presenter_no + '_first_name' ).prop( 'disabled', true );
			$form.find( '#self_organised_symposium_form-sos_presenter_' + presenter_no + '_last_name' ).prop( 'disabled', true );
		} else {
			$form.find( 'input.i-am-presenter' ).not( this ).prop( 'disabled', false );
			$form.find( '#self_organised_symposium_form-sos_presenter_' + presenter_no + '_email' ).prop( 'disabled', false );
			$form.find( '#self_organised_symposium_form-sos_presenter_' + presenter_no + '_first_name' ).prop( 'disabled', false );
			$form.find( '#self_organised_symposium_form-sos_presenter_' + presenter_no + '_last_name' ).prop( 'disabled', false );
		}
	};

	let _move_to_submitted = function( e ) {
		e.preventDefault();

		let data = {
			action: 'crate_move_symposium_to_submitted',
			nonce: ScriptData.crate_move_symposium_to_submitted_nonce,
			symposium: $( this ).data( 'symposium' ),
			redirect: $( this ).attr( 'href' ),
		};

		$( '.ajax-spinner' ).addClass( 'active' );
		$( 'body' ).addClass( 'crate-loading' );

		$.post( ScriptData.ajaxurl, data, _move_to_submitted_response );
	};

	let _move_to_submitted_response = function( response ) {

		if ( response.success ) {
			window.location.href = response.redirect;
		}
	};

	let _update_word_count = function( e ) {
		let val = $overview.val();
		let words = val ? val.trim().split( ' ' ) : [];
		let total_words = words.length;

		let $count = $( '.nav-section' ).find( '.count' );
		let words_remaining = parseInt( $count.data( 'total' ) ) - total_words;

		$count.text( words_remaining );

		if ( words_remaining < 0 ) {
			$count.addClass( 'invalid' );
		} else {
			$count.removeClass( 'invalid' );
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = submit_symposium;